<template>
    <div>
        <div class="text-center">
            <v-dialog
                    v-model="dialog"
                    transition="dialog-bottom-transition"
                    width="500"
            >
                <template v-slot:activator="{ on }">
                    <slot>
                        <v-btn  @click="on.click" text>
                            <BookingStatusChip v-model="value"/>
                        </v-btn>

                    </slot>
                </template>

                <v-card>
                    <v-card-title class="headline grey lighten-2">
                        Update Booking Status
                    </v-card-title>

                    <v-card-text>
                        <div>
                            <v-combobox
                                    label="Status"
                                    v-model="status"
                                    :items="statuses"
                                    item-text="name"
                                    item-value="name"
                                    :loading="$apollo.loading"

                            />
                            <v-textarea
                                    label="Reason"
                                    v-model="reason"
                                    r

                            />
                        </div>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                                color="primary"
                                @click="update"
                                :disabled="updating"
                        >
                            Update
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>

    import GET_BOOKING_STATUSES from "../../graphql/Bookings/GetBookingStatuses.gql";
    import UPDATE_BOOKING_STATUS from "../../graphql/Bookings/UpdateBookingStatus.gql";
    import BookingStatusChip from "./BookingStatusChip";

    export default {
        components: {BookingStatusChip},
        props: {
            value: {
                type: Object,
            },
            bookingId: {
                type: String,
                default: null
            },
        },
        data() {
            return {
                dialog: false,
                updating: false,
                status: null,
                reason: null,
            }
        },
        apollo: {
            statuses: {
                query: GET_BOOKING_STATUSES,
                update: data => data.__type.enumValues
            },
        },

        methods: {

            update() {
                this.updating = true

                this.$apollo.mutate({
                    mutation: UPDATE_BOOKING_STATUS,
                    variables: {
                        id: this.bookingId,
                        name: this.status.name,
                        reason: this.reason
                    },
                }).then(() => {
                    this.updating = false
                    this.status = null
                    this.reason = null
                    this.$emit('updated');
                    this.$store.dispatch('notification/addSuccess', 'Booking Status Updated successful')
                    this.value = false
                    this.dialog = false
                }).catch(({error}) => {
                    console.log(error)
                    this.$store.dispatch('notification/handleGraphQlError', error)
                })
            },
        },
    }
</script>

<style scoped>

</style>